module.exports = __webpack_public_path__ + "img/devices-logo-active.93ae261d.svg";